import { render } from "./RaceResultsSliderItem.vue?vue&type=template&id=0568cbb4&scoped=true"
import script from "./RaceResultsSliderItem.vue?vue&type=script&lang=js"
export * from "./RaceResultsSliderItem.vue?vue&type=script&lang=js"

import "./RaceResultsSliderItem.vue?vue&type=style&index=0&id=0568cbb4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0568cbb4"]])

export default __exports__